import { ReportParameterValue } from '../models/report-parameter-value.model';
import { ReportView, ReportGroup, ReportParameter, ReportGenerateResult, ReportReservedParameter } from '../models';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
const httpHeaders: HttpHeaders = new HttpHeaders().append('ReportClientId', environment.reportConfig.clientId);

@Injectable({
  providedIn: 'root'
})
export class ReportsHttpService {
  constructor(private http: HttpClient) {
  }

  getMyReports(clientId: string): Observable<ReportView[]> {
    return this.http.get<ReportView[]>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/` + clientId + '/Mine', { headers: httpHeaders });
  }

  getReportsForUser(clientId: string, userRef: string): Observable<ReportView[]> {
    return this.http.get<ReportView[]>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/` + clientId + '/ReportsByUserRef/' + userRef, { headers: httpHeaders });
  }

  getMyReportsAndGroup(clientId: string): Observable<ReportGroup[]> {
    return this.getMyReports(clientId).pipe(
      map((items: ReportView[]) => this.convertToGrouping(items)));
  }

  convertToGrouping(items: ReportView[]): ReportGroup[] {
    const result: ReportGroup[] = [];

    items.forEach((item: ReportView) => {
      if (!result.some((c) => c.name === item.groupName)) {
        result.push({ name: item.groupName, reports: [] });
      }
      const group = result.find((c) => c.name === item.groupName);
      group.reports.push({ name: item.name, id: item.id, selected: false });
    });

    return result;
  }

  getMyReportParameters(clientId: string, reportId: string, reportParameterValues: ReportParameterValue[])
    : Observable<ReportParameter[]> {
    return this.http.put<ReportParameter[]>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/`
      + clientId + '/reports/' + reportId + '/parameters', reportParameterValues, { headers: httpHeaders });
  }

  generateReportRequest(clientId: string, reportId: string, requestParams: ReportParameter[]): Observable<ReportGenerateResult> {
    return this.http.post<ReportGenerateResult>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/`
      + clientId + '/reports/' + reportId, requestParams, { headers: httpHeaders });
  }

  getReports(clientId: string): Observable<ReportView[]> {
    return this.http.get<ReportView[]>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/` + clientId, { headers: httpHeaders });
  }

  getReportReservedParameters(clientId: string, reportId: string): Observable<ReportReservedParameter[]> {
    return this.http.get<ReportReservedParameter[]>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/`
      + clientId + '/reports/' + reportId + '/parameters/reserved', { headers: httpHeaders });
  }

  updateReportsForUser(clientId: string, userRef: string, reports: ReportView[]): Observable<null> {
    return this.http.post<null>(`${environment.reportConfig.reportApiBaseAddress}ClientReports/`
      + clientId + '/userRef/' + userRef, reports, { headers: httpHeaders });
  }
}
